/**
 * Per-tab persistence for state that belongs to one simulator run rather than to the user:
 * sessionStorage is per tab and survives a reload, where localStorage is one slot every tab
 * overwrites. It is copied into a tab opened from this one and absent from one opened by
 * hand, so it is never a hand-off; what a second tab must be told travels in the URL.
 */

import { createJSONStorage } from 'jotai/utils';

export const tabStorage = <T>() => createJSONStorage<T>(() => sessionStorage);
